import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ButtonPlus from "../../Components/SelectValue/ButtonPlus";
import AddInvestment from "../../Components/Transaction/AddInvestment";
import CreateCategory from "../../Components/Transaction/createCategory";
import InvestmentCategory from "../../Components/Transaction/InvestmentCategory";
import InvestmentPlan from "../../Components/Transaction/InvestmentPlan";
import InvestmentSubscribers from "../../Components/Transaction/Users"; 

function Investment() {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const location = useLocation();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const isCategoryPage = location.pathname.split('/').filter(Boolean).length === 1;
  
  const isInvestmentPlanPage = location.pathname.split('/').filter(Boolean).length === 2;

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const categoryId = pathSegments[1] || null;

  return (
    <div className="p-6">
      <AddInvestment open={open} handleClose={handleClose} categoryId={categoryId}/>
      <CreateCategory open={open2} handleClose={handleClose2} />

      <div className="flex gap-4 mb-6">
        {isCategoryPage && (
          <ButtonPlus name="Add Investment Category" onClick={handleOpen2} />
        )}
        {isInvestmentPlanPage && (
          <ButtonPlus name="Add Investment Plan" onClick={handleOpen} />
        )}
      </div>

      <Routes>
        <Route path="/" element={<InvestmentCategory />} />
        <Route path=":categoryId" element={<InvestmentPlan />} />
        <Route
          path=":categoryId/:investmentId"
          element={<InvestmentSubscribers />} 
        />
      </Routes>
    </div>
  );
}

export default Investment;